<template>
  <div>
    <el-form role="form" @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-4">
          <base-input label="Select Field">
            <el-select v-model="currentFilter" selected-filters:->
              <el-option label="Customer Name" value="customerName" />
              <el-option label="Invoice Number" value="invoiceNumber" />
              <el-option label="Date" value="date" />
              <el-option label="Payment Status" value="status" />
              <el-option
                label="Service Request Number"
                value="serviceRequestNumber"
              />
              <el-option label="Branch" value="branch" />
            </el-select>
          </base-input>
        </div>
        <div class="col-md-8">
          <base-input v-if="currentFilter === 'status'" label="Select Value">
            <el-select v-model="selectedValue">
              <el-option
                v-for="(item, index) in statuses"
                :key="index"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </base-input>
          <base-input v-if="currentFilter === 'branch'" label="Select Value">
            <el-select v-model="selectedBranch">
              <el-option
                v-for="(item, index) in branches"
                :key="index"
                :value="item"
                :label="item.name"
              />
            </el-select>
          </base-input>
          <base-input
            v-else-if="currentFilter != 'date'"
            v-model="selectedValue"
            selected-filters:-
            label="Value"
            placeholder="Type Value"
          />

          <base-input v-else label="Select Date Range">
            <el-date-picker
              v-model="selectedValue"
              type="daterange"
              range-separator="-"
              start-placeholder="Start"
              end-placeholder="End"
              value-format="yyyy-MM-dd"
            />
          </base-input>
        </div>
      </div>
      <base-button type="primary" native-type="submit">Apply</base-button>
    </el-form>
  </div>
</template>

<script>
import { Form, Select, Option, DatePicker } from "element-ui";
import { apiHelper } from "../utils/helpers";
import endpoints from "@/utils/constants";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form,
    [DatePicker.name]: DatePicker
  },
  data() {
    return {
      currentFilter: null,
      selectedValue: null,
      selectedBranch: null,
      statuses: [
        {
          value: "pending",
          label: "Pending"
        },
        {
          value: "completed",
          label: "Completed"
        }
      ],
      branches: []
    };
  },
  mounted() {
    this.getBranches();
  },
  methods: {
    onSubmit() {
      this.$emit("apply", {
        field: this.currentFilter,
        value:
          this.currentFilter === "branch"
            ? this.selectedBranch.id
            : this.selectedValue,
        label:
          this.currentFilter === "branch"
            ? this.selectedBranch.name
            : this.selectedValue
      });
      this.currentFilter = "";
      this.selectedValue = "";
    },
    getBranches() {
      apiHelper
        .call("get", `${endpoints.LARAVEL_BASE_URL}/api/v1/branches`)
        .then(res => {
          this.branches = res.data.data;
        })
        .catch(() => {
          this.$notify({
            message: "Something Went Wrong!",
            type: "danger",
            title: "error"
          });
        });
    }
  }
};
</script>

<style></style>
